<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}条{{this.route.menuName}}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" type="danger" size="small" :disabled="multiple" v-preventReClick @click="handleDelete">删除</el-button>

          <!-- <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange" @reset="reset"></SelectFilter> -->
        </div>
        <div class="right">
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <div style="margin-bottom: 10px">
        <el-tabs v-model="query.sourceType" @tab-click="tabClick" stretch style="width: 30%;">
          <el-tab-pane v-for="item in systemType" :key="item.id" :name="item.id">
            <template slot="label">
              <!--  -->
              <el-badge class="item">
                <span style="margin: 0 10px"> {{ item.name }} </span>
              </el-badge>
            </template>
          </el-tab-pane>
        </el-tabs>
      </div>

      <el-table ref="multipleTable" border row-key="id" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="oldName" min-width="120" label="原注册证名称">
          <template slot-scope="scope">
            <span>{{ scope.row.oldName?scope.row.oldName:'-' }}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="name" label="注册证名称" min-width="120"></el-table-column>
        <el-table-column show-overflow-tooltip prop="oldNo" v-if="query.sourceType==1" min-width="120" label="原注册证号">
          <template slot-scope="scope">
            <span>{{ scope.row.oldNo?scope.row.oldNo:'-' }}</span>
          </template>
        </el-table-column>
         <el-table-column show-overflow-tooltip prop="oldNo" v-else min-width="120" label="原批准文号"></el-table-column>
          <el-table-column prop="no" v-if="query.sourceType==1" label="注册证号" min-width="180">
            <template slot-scope="scope">
              <span>
                <el-link type="primary" @click="handleInfo(scope.row)">{{ scope.row.no }}</el-link>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="no" v-else label="批准文号" min-width="180">
            <template slot-scope="scope">
              <span>
                <el-link type="primary" @click="handleInfo(scope.row)">{{ scope.row.no }}</el-link>
              </span>
            </template>
          </el-table-column>
        <el-table-column prop="supplierName" label="发起人" min-width="120"></el-table-column>
        <el-table-column v-if="isWorkflowTable" label="审批人" width="100" align="center" prop="approverNames"></el-table-column>
        <el-table-column prop="statusName" label="流程状态" width="80" v-if="isWorkflowTable">
          <template slot-scope="scope">
            <approve-status :row="scope.row" :isWorkflowTable="isWorkflowTable" :options="ApproveStatusOptions" @success="getData" :tableCode="route.name"></approve-status>
          </template>
        </el-table-column>
        <el-table-column prop="createdTime" width="170" label="创建时间">
          <template slot-scope="scope">
            {{ parseTime(new Date(scope.row.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }}
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.remark?scope.row.remark:'-' }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" prop="operation" label="操作" width="180">
          <template slot-scope="scope">
            <!-- <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button> -->
            <el-button v-if="
                scope.row.status == 1 &&
                  isShowApproveButton(scope.row.approverIds)
              " type="text" v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button>
            <el-button v-if="tableAcl.indexOf('Remove') != -1 && scope.row.status != 2" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  GetProductRegistCertUpdates,
  RemoveProductRegistCertUpdate,
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
// import { StockCategoryOptions, WhetherOptions, ApproveStatusOptions } from "@/enum";
import SelectFilter from "@/components/table-select-filter";
import BaseListMixin from '@/mixin/baseList-mixin.js'

export default {
  mixins: [GetDataMixin, BaseListMixin],
  components: {
    SelectFilter,
  },
  data () {
    return {
      GetDatasAction: GetProductRegistCertUpdates,
      RemoveAction: RemoveProductRegistCertUpdate,
      editPath: 'product-regist-cert-update-edit',
      systemType: [
            {
              id: 1,
              name: "耗材",
            },
            {
              id: 2,
              name: "药品",
            }
          ],
    };
  },
  methods: {
    tabClick() {
          this.getData();
        },
  },
  mounted () {
    this.query.sourceType = 1
  },
};
</script>

<style lang="scss" scoped></style>
